<template>
  <div>
    <v-btn icon @click="openDialog()">
      <v-icon :color="ui.btnColor">
        subject
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textHeadline">
          <v-layout row>
            <v-icon left medium :color="ui.iconColor"> summarize </v-icon>
            <span :class="ui.textTitle">
              Document Revision Detail
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> pin </v-icon>
              </v-avatar>
              {{displayDocumentIDGTypeA(this.getDetailBasic.tag, this.getDetailBasic.idg)}}
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.getDetailBasic.link === true">
              <v-icon> link </v-icon>
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.getDetailBasic.save === true && this.getDetailBasic.tag !== 'U1'">
              <v-icon :color="ui.btnColorWarning"> save </v-icon>
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.getDetailBasic.lock === true">
              <v-icon :color="ui.btnColorWarning"> lock </v-icon>
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.displayDocumentRevTypeA(this.getDetailRev)}}
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> title </v-icon>
              </v-avatar>
              {{getDetailBasic.title}}
            </v-chip>
            <v-spacer/>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="this.getDetailBasic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> sell </v-icon>
              </v-avatar>
              {{getDetailBasic.id}}
            </v-chip>
            <v-spacer/>
          </v-layout>
          <v-layout class="mt-4"/>
          <v-layout row class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> book </v-icon>
              </v-avatar>
              Tag
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ getDetailBasic.tag }}
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> bookmark_border </v-icon>
              </v-avatar>
              Type
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ getDetailRev.type }}
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> security </v-icon>
              </v-avatar>
              Security
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.getDetailRev.sec}}
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> sync_alt </v-icon>
              </v-avatar>
              Status
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.getDetailRev.stat}}
            </v-chip>
          </v-layout>
          <v-layout class="mt-4"/>
          <v-layout class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> change_history </v-icon>
              </v-avatar>
              Modifications
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.getDetailRev.nmod}}
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> post_add </v-icon>
              </v-avatar>
              Revisions
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.getDetailRev.nrev}}
            </v-chip>
          </v-layout>
          <v-layout class="mt-4"/>
          <v-layout class="text-xs-left ml-4 mr-2 hidden-xs-only">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> today </v-icon>
              </v-avatar>
              Created
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{dateTypeB(this.getDetailStats.dcrt)}}
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2 hidden-xs-only">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> edit_calendar </v-icon>
              </v-avatar>
              Updated
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{dateTypeB(this.getDetailStats.dedit)}}
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2 hidden-xs-only">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> event_available </v-icon>
              </v-avatar>
              Review
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{dateTypeA(this.getDetailStats.drev)}}
            </v-chip>
          </v-layout>
          <!-- <v-layout class="text-xs-left ml-4 mr-2" v-if="this.getDetailBasic.tag === 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> login </v-icon>
              </v-avatar>
              Signed In
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{dateTypeB(this.stats.dsin)}}
            </v-chip>
          </v-layout> -->
          <!-- <v-layout class="text-xs-left ml-4 mr-2" v-if="this.getDetailBasic.tag === 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> logout </v-icon>
              </v-avatar>
              Signed Out
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{dateTypeB(this.stats.dsout)}}
            </v-chip>
          </v-layout> -->
          <v-layout class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> create </v-icon>
              </v-avatar>
              Mod
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.getDetailRev.modc === this.getDetailRev.modm">
              {{this.getDetailRev.modc}}
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-else>
              {{this.getDetailRev.modc}} / {{this.getDetailRev.modc}}
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2 hidden-xs-only">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> textsms </v-icon>
              </v-avatar>
              Change
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.getDetailRev.modcc}}
            </v-chip>
          </v-layout>
          <v-layout class="mt-4"/>
          <v-layout class="text-xs-left ml-4 mr-2 hidden-xs-only"
          v-if="this.getDetailBasic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> person </v-icon>
              </v-avatar>
              Prepared by
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.getDetailRev.uname}}
            </v-chip>
          </v-layout>
          <v-layout class="text-xs-left ml-4 mr-2 hidden-xs-only"
          v-if="this.getDetailBasic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> email </v-icon>
              </v-avatar>
              Contact
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{this.getDetailRev.uemail}}
            </v-chip>
          </v-layout>
          <div v-if="
          this.getDetailRev.modc === 1.63 ||
          this.getDetailRev.modm === 1.63
          " class="ml-2">
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4">
                Document Rev. Update by User
              </div>
            </v-layout>
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4">
                {{getDetailRev.com}}
              </div>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";

export default {
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  mixins: [apptheme, revFunctions, dateFunctions, displayFunctions],
  computed: {
    ...mapGetters(["getDetailRev", "getDetailStats", "getDetailBasic"]),
    tag() {
      return this.getDetail.basic.tag;
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
